// extracted by mini-css-extract-plugin
export default {"fullPageLoadingLayer":"FullPageLoadingLayer-module__fullPageLoadingLayer___3x7tv"};